export enum Type {
    PAYROLL = 'payroll',
}

export const ERROR_STATUS = 'res is not iterable';

export const TOOLTIP_INFORMATION =
    'Estos contratos están próximos a vencer, recuerda que un mes antes debes reportar al empleado de manera anticipada al vencimiento de su contrato.';
